import React, { useCallback } from "react";

import Checkbox from "antd/es/checkbox";
import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Popconfirm } from "@mapmycustomers/ui";

import ButtonLink from "@app/component/ButtonLink";

const messages = defineMessages({
  disabledTooltip: {
    id: "integrations.fieldMappingTable.column.disabledTooltip",
    defaultMessage: "Field must be mapped to create groups",
    description: "Disabled checkbox Tooltip",
  },
  popConfirmOk: {
    id: "integrations.fieldMappingTable.column.popConfirmOk",
    defaultMessage: "I’m sure",
    description: "Text of a popConfirm ok button",
  },
  popConfirmPopupLink: {
    id: "integrations.fieldMappingTable.column.popConfirmPopupLink",
    defaultMessage: "Learn how grouping with integrations work",
    description: "Text of a popConfirm Learn Popup Link",
  },
  popConfirmText: {
    id: "integrations.fieldMappingTable.column.popConfirmText",
    defaultMessage: "Are you sure you want to create groups from the values of this field?",
    description: "Text of a popConfirm ok button",
  },
});

const POP_CONFIRM_ALIGN = {
  offset: [11, 0],
};

interface Props {
  disabled?: boolean;
  mmcGroupField: null | string;
  onChangeGrouping: (enabled: boolean) => void;
  onShowGroupFieldInfoModal: () => void;
}

export const ChangeGrouping = ({
  disabled,
  mmcGroupField,
  onChangeGrouping,
  onShowGroupFieldInfoModal,
}: Props) => {
  const intl = useIntl();
  const [visible, show, hide] = useBoolean();

  const currentChecked = !!mmcGroupField;

  const handleCheckboxClick = useCallback(
    ({ currentTarget: { checked } }: React.MouseEvent<HTMLInputElement>) => {
      if (checked || !currentChecked) {
        show();
      } else {
        hide();
      }
      if (!checked) {
        onChangeGrouping(false);
      }
    },
    [currentChecked, onChangeGrouping, show, hide]
  );

  const handleConfirm = useCallback(() => {
    onChangeGrouping(true);
    hide();
  }, [onChangeGrouping, hide]);

  if (disabled) {
    return (
      <Tooltip title={intl.formatMessage(messages.disabledTooltip)}>
        <Checkbox disabled />
      </Tooltip>
    );
  }

  return (
    <Popconfirm
      align={POP_CONFIRM_ALIGN}
      description={
        <ButtonLink onClick={onShowGroupFieldInfoModal}>
          {intl.formatMessage(messages.popConfirmPopupLink)}
        </ButtonLink>
      }
      okText={intl.formatMessage(messages.popConfirmOk)}
      onCancel={hide}
      onConfirm={handleConfirm}
      placement="topRight"
      title={intl.formatMessage(messages.popConfirmText)}
      visible={visible}
    >
      <Checkbox checked={currentChecked} onClick={handleCheckboxClick} />
    </Popconfirm>
  );
};
